import { styled, Typography, Grid, Box, Stack } from '@mui/material';

import { AccessRequestClientModel, useGetUserSession } from '@apono/client-app-sdk';

import { DateTime } from '@common/utils/datetime';
import LabeledData from '@common/ui/LabeledData';

import RequestorCell from './RequestorCell';

const StyledPaper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
}));

export default function TaskOverview({ request }: { request: AccessRequestClientModel }) {
  const { data: userSession } = useGetUserSession();
  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2">Overview:</Typography>
      <StyledPaper>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <LabeledData label="Created" value={DateTime.fromUnix(Number(request.creation_time)).readable} />
          </Grid>
          <Grid item xs={6}>
            <LabeledData label="Requestor" value={<RequestorCell requestor={request.requestor} />} />
          </Grid>
          {userSession?.settings.request_custom_fields?.map((customField) => {
            const value = request.custom_fields?.[customField.id];
            if (!value) return null;
            return (
              <Grid item xs={6} key={customField.id}>
                <LabeledData label={customField.label} value={value} />
              </Grid>
            );
          })}
          {request.bundle && (
            <Grid item xs={6}>
              <LabeledData label="Bundle" value={request.bundle.name} />
            </Grid>
          )}
          <Grid item xs={6}>
            <LabeledData label="Justification" value={request.justification} />
          </Grid>
        </Grid>
      </StyledPaper>
    </Stack>
  );
}
